import { InstallGuide } from '../components/InstallGuide';
import { Page } from '../components/layout';
import { useT } from '../i18n';

/** True when react-router has an in-app entry to go back to (it stores `idx` in history.state). */
function canGoBack(): boolean {
  const st = window.history.state as { idx?: number } | null;
  return typeof st?.idx === 'number' && st.idx > 0;
}

/** /install — the Home-Screen guide inside the app shell (linked from Settings and banners). */
export default function InstallScreen() {
  const t = useT();
  return (
    <Page title={t('auth.install.title')} back={canGoBack() ? true : '/settings'}>
      <div className="mx-auto max-w-2xl">
        <InstallGuide />
      </div>
    </Page>
  );
}
